import { Typography } from 'shared/mui/Typography';

export type PageHeaderDescriptionProps = {
  description: string;
};

export function PageHeaderDescription({ description }: PageHeaderDescriptionProps): JSX.Element {
  return <Typography sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>{description}</Typography>;
}
